import React from 'react';
import NoAccessOverlay from '@/finsight/ui/common/components/NoAccessOverlay';
import {
  leagueTablesImageCaption,
  leagueTablesNoAccessDescription,
  leagueTablesNoAccessFeatures,
  PAGE_TITLE,
} from '@/finsight/ui/components/league/LeagueTablePage/constants';
import image from '@/finsight/ui/assets/noAccess/leagueTablesNoAccess.webp';

export const LeagueTablesNoAccessComponent = (
  <NoAccessOverlay
    title={ PAGE_TITLE }
    features={ leagueTablesNoAccessFeatures }
    description={ leagueTablesNoAccessDescription }
    imageCaption={ leagueTablesImageCaption }
    image={ image }
    isDoubleImage
  />
);
